/** @format */

import React from "react";
import Blogs from "../Blogs";
import Newsletter from "../Newsletter";
import Media from "../Media";
import CaseStudy from "../CaseStudy";
import Newsroom from "../Newsroom";
import { Route } from "react-router-dom";
import BlogOne from "../Blogs/BlogOne";
import BlogTwo from "../Blogs/BlogTwo";
import BlogThree from "../Blogs/BlogThree";
import BlogFour from "../Blogs/BlogFour";
import BlogFive from "../Blogs/BlogFive";
import BlogSix from "../Blogs/BlogSix";
import BlogSeven from "../Blogs/BlogSeven";
import BlogEight from "../Blogs/BlogEight";
import BlogNine from "../Blogs/BlogNine";
import BlogTen from "../Blogs/BlogTen";
import BlogEleven from "../Blogs/BlogEleven";
import BlogTwelve from "../Blogs/BlogTwelve";
import BlogThirteen from "../Blogs/BlogThirteen";
import BlogFourteen from "../Blogs/BlogFourteen";
import BlogFifteen from "../Blogs/BlogFifteen";
import BlogSixteen from "../Blogs/BlogSixteen";
import BlogSeventeen from "../Blogs/BlogSeventeen";
import BlogEighteen from "../Blogs/BlogEighteen";
import BlogNineteen from "../Blogs/BlogNineteen";
import BlogTwenty from "../Blogs/BlogTwenty";
import BlogTwentyOne from "../Blogs/BlogTwentyOne";
import NewsroomMediaOne from "../Newsroom/NewsroomMediaOne";
import BlogTwentyTwo from "../Blogs/BlogTwentyTwo";
import BlogTwentyThree from "../Blogs/BlogTwentyThree";
import Podcast from "../Podcast";
import PodcastInfoContainer from "../Podcast/containers/PodcastInfoContainer";
import BlogTwentyFour from "../Blogs/BlogTwentyFour";
import BlogTwentyFive from "../Blogs/BlogTwentyFive";
import BlogTwentySix from "../Blogs/BlogTwentySix";
import BlogTwentySeven from "../Blogs/BlogTwentySeven";
import BlogTwentyEight from "../Blogs/BlogTwentyEight";
import BlogTwentyNine from "../Blogs/BlogTwentyNine";
import BlogThirty from "../Blogs/BlogThirty";
import BlogThirtyOne from "../Blogs/BlogThirtyOne";
import BlogThirtyTwo from "../Blogs/BlogThirtyTwo";
import BlogThirtyThree from "../Blogs/BlogThirtyThree";
import NewsroomMediaTwo from "../Newsroom/NewsroomMediaTwo";
import BlogThirtyFour from "../Blogs/BlogThirtyFour";
import BlogThirtyFive from "../Blogs/BlogThirtyFive";
import BlogThirtySix from "../Blogs/BlogThirtySix";
import BlogThirtySeven from "../Blogs/BlogThirtySeven";
import BlogThirtyEight from "../Blogs/BlogThirtyEight";
import BlogThirtyNine from "../Blogs/BlogThirtyNine";
import BlogForty from "../Blogs/BlogForty";
import BlogFortyOne from "../Blogs/BlogFortyOne";
import BlogFortyTwo from "../Blogs/BlogFortyTwo";
import BlogFortyThree from "../Blogs/BlogFortyThree";
import BlogFortyFour from "../Blogs/BlogFortyFour";
import BlogFortyFive from "../Blogs/BlogFortyFive";
import BlogFortySix from "../Blogs/BlogFortySix";
import BlogFortySeven from "../Blogs/BlogFortySeven";
import Blog_48 from "../Blogs/Blog_48";
import Blog_49 from "../Blogs/Blog_49";
import NewsroomMediaThree from "../Newsroom/NewsroomMediaThree";
import Blog_50 from "../Blogs/Blog_50";
import Blog_50_1 from "../Blogs/Blog_50_1";
import Blog_50_2 from "../Blogs/Blog_50_2";
import Blog_50_3 from "../Blogs/Blog_50_3";
import Blog_50_4 from "../Blogs/Blog_50_4";
import Blog_50_5 from "../Blogs/Blog_50_5";
import Blog_50_6 from "../Blogs/Blog_50_6";
import Blog_50_7 from "../Blogs/Blog_50_7";
import Blog_50_8 from "../Blogs/Blog_50_8";
import Blog_50_9 from "../Blogs/Blog_50_9";
import Blog_50_10 from "../Blogs/Blog_50_10";
import Blog_51 from "../Blogs/Blog_51";
import Blog_52 from "../Blogs/Blog_52";
import Blog_53 from "../Blogs/Blog_53";
import Blog_54 from "../Blogs/Blog_54";
import Blog_55 from "../Blogs/Blog_55";
import Blog_56 from "../Blogs/Blog_56";
import Blog_57 from "../Blogs/Blog_57";
import Blog_58 from "../Blogs/Blog_58";
import Blog_59 from "../Blogs/Blog_59";
import Blog_60 from "../Blogs/Blog_60";

function Resource({ newslettersData, mediaData, podcastData }) {
  return (
    <>
      <Route path="/resource/blogs" exact>
        <Blogs blogsData={newslettersData} />
      </Route>
      <Route path="/resource/newsletter" exact>
        <Newsletter newslettersData={newslettersData}></Newsletter>
      </Route>
      <Route path="/resource/media" exact>
        <Media mediaData={mediaData}></Media>
      </Route>
      <Route path="/resource/newsroom" exact>
        <Newsroom mediaData={mediaData}></Newsroom>
      </Route>
      <Route path="/resource/podcast" exact>
        <Podcast podcastData={podcastData}></Podcast>
      </Route>
      <Route path="/resource/case-study" exact>
        <CaseStudy newslettersData={newslettersData}></CaseStudy>
      </Route>
      <Route path="/resource/podcast/:info" exact>
        <PodcastInfoContainer />
      </Route>
      <Route path="/resource/blogs/what-do-net-zero-emission-targets-mean">
        <BlogOne></BlogOne>
      </Route>
      <Route path="/resource/blogs/the-need-for-a-sustainable-business-behavior">
        <BlogTwo></BlogTwo>
      </Route>
      <Route path="/resource/blogs/why-diversity-in-integral-to-a-sustainable-business">
        <BlogThree></BlogThree>
      </Route>
      <Route path="/resource/blogs/sustainability-and-the-pandemic">
        <BlogFour></BlogFour>
      </Route>
      <Route path="/resource/blogs/world-environment-day">
        <BlogFive></BlogFive>
      </Route>
      <Route path="/resource/blogs/sea-level-rise-and-it-s-impact">
        <BlogSix></BlogSix>
      </Route>
      <Route path="/resource/blogs/the-road-to-sustainable-development-how-the-sdgs-are-reinforced-in-india">
        <BlogSeven></BlogSeven>
      </Route>
      <Route path="/resource/blogs/what-happens-when-we-discard-our-phone-for-a-smarter-one">
        <BlogEight></BlogEight>
      </Route>
      <Route path="/resource/blogs/sustainability-and-the-fashion-industry">
        <BlogNine></BlogNine>
      </Route>
      <Route path="/resource/blogs/responsible-companies-and-a-responsible-nation-an-insight-to-csr-in-india">
        <BlogTen></BlogTen>
      </Route>
      <Route path="/resource/blogs/sustainability-let-s-make-it-better">
        <BlogEleven></BlogEleven>
      </Route>
      <Route path="/resource/blogs/sdgs-101">
        <BlogTwelve></BlogTwelve>
      </Route>
      <Route path="/resource/blogs/are-evs-the-way-of-the-future">
        <BlogThirteen></BlogThirteen>
      </Route>
      <Route path="/resource/blogs/debunking-the-myths">
        <BlogFourteen></BlogFourteen>
      </Route>
      <Route path="/resource/blogs/Understanding-the-greenhouse-gases">
        <BlogFifteen></BlogFifteen>
      </Route>
      <Route path="/resource/blogs/Let's-talk-about-Carbon-Taxes">
        <BlogSixteen></BlogSixteen>
      </Route>
      <Route path="/resource/blogs/Understanding-the-Greenhouse-Gases-CH4">
        <BlogSeventeen></BlogSeventeen>
      </Route>
      <Route path="/resource/blogs/Extreme-weather-events-and-how-they-are-linked-to-Climate-Change">
        <BlogEighteen></BlogEighteen>
      </Route>
      <Route path="/resource/blogs/understanding-climate-justice">
        <BlogNineteen></BlogNineteen>
      </Route>
      <Route path="/resource/blogs/let's-talk-about-biofuels">
        <BlogTwenty />
      </Route>
      <Route path="/resource/blogs/where-does-the-world-stand-with-sdg-2030-today">
        <BlogTwentyOne />
      </Route>
      <Route path="/resource/newsroom/dnv-scpa-collaborates-with-updapt-an-esg-tech-co-to-transform-your-sustainability-journey-230553">
        <NewsroomMediaOne />
      </Route>
      <Route
        path="/resource/blogs/importance-of-an-esg-report-for-a-better-esg-management"
        exact
      >
        <BlogTwentyTwo />
      </Route>
      <Route path="/resource/blogs/how-can-we-achieve-decarbonization" exact>
        <BlogTwentyThree />
      </Route>
      <Route path="/resource/blogs/benefits-of-impact-investment" exact>
        <BlogTwentyFour />
      </Route>
      <Route path="/resource/blogs/internal-carbon-pricing" exact>
        <BlogTwentyFive />
      </Route>
      <Route
        path="/resource/blogs/different-terms-but-the-goal-is-lets-go-net-zero"
        exact
      >
        <BlogTwentySix />
      </Route>
      <Route path="/resource/blogs/the-importance-of-integrating-dei" exact>
        <BlogTwentySeven />
      </Route>
      <Route
        path="/resource/blogs/updapt-esg-all-in-One-sustainability-software"
        exact
      >
        <BlogTwentyEight />
      </Route>
      <Route
        path="/resource/blogs/details-about-esg-data-management-software-for-2024"
        exact
      >
        <BlogTwentyNine />
      </Route>{" "}
      <Route path="/resource/blogs/transition-pathway-initiative" exact>
        <BlogThirty />
      </Route>{" "}
      <Route
        path="/resource/blogs/esg-software-for-small-businesses-in-2024-updapt"
        exact
      >
        <BlogThirtyOne />
      </Route>{" "}
      <Route
        path="/resource/blogs/choose-wisely-esg-and-sustainability-reporting-software-for-your-business"
        exact
      >
        <BlogThirtyTwo />
      </Route>{" "}
      <Route
        path="/resource/blogs/updapt-esg-reporting-software-for-real-estate-portfolio-and-investors"
        exact
      >
        <BlogThirtyThree />
      </Route>{" "}
      <Route
        path="/resource/newsroom/updapt-an-esg-tech-co-partners-with-grant-thornton-advisory-east-africa"
        exact
      >
        <NewsroomMediaTwo />
      </Route>
      <Route
        path="/resource/blogs/esg-software-for-manufacturing-industries"
        exact
      >
        <BlogThirtyFour />
      </Route>
      <Route
        path="/resource/blogs/esg-software-for-pharmaceutical-industries"
        exact
      >
        <BlogThirtyFive />
      </Route>
      <Route path="/resource/blogs/esg-frameworks-have-in-esg-reporting" exact>
        <BlogThirtySix />
      </Route>
      <Route path="/resource/blogs/what-is-carbon-accounting" exact>
        <BlogThirtySeven />
      </Route>
      <Route
        path="/resource/blogs/minimize-the-environmental-impact-of-e-commerce-logistics"
        exact
      >
        <BlogThirtyEight />
      </Route>
      <Route path="/resource/blogs/esg-data-management-software-for-uae" exact>
        <BlogThirtyNine />
      </Route>
      <Route path="/resource/blogs/what-are-the-scope-1-2-3-4-emission" exact>
        <BlogForty />
      </Route>
      <Route path="/resource/blogs/what-is-double-materiality" exact>
        <BlogFortyOne />
      </Route>
      <Route path="/resource/blogs/esg-data-management" exact>
        <BlogFortyTwo />
      </Route>
      <Route path="/resource/blogs/what-is-esg-compliance" exact>
        <BlogFortyThree />
      </Route>
      <Route
        path="/resource/blogs/how-sustainability-reporting-standards-shaping-future-of-corporate-responsibility"
        exact
      >
        <BlogFortyFour />
      </Route>
      <Route
        path="/resource/blogs/net-zero-esg-how-emissions-reduction-ties-into-sustainablity-reporting"
        exact
      >
        <BlogFortyFive />
      </Route>
      <Route
        path="/resource/blogs/why-esg-reporting-matters-in-india-regulations-trends-and-the-future-ahead"
        exact
      >
        <BlogFortySix />
      </Route>
      <Route
        path="/resource/blogs/sustainability-reporting-vs-esg-reporting-key-differences-and-business-impact"
        exact
      >
        <BlogFortySeven />
      </Route>
      <Route
        path="/resource/blogs/understanding-esg-reporting-frameworks-popular-standard-guide"
        exact
      >
        <Blog_48 />
      </Route>
      <Route
        path="/resource/blogs/why-csr-reporting-frameworks-moving-towards-esg-reporting-integration"
        exact
      >
        <Blog_49 />
      </Route>
      <Route
        path="/resource/newsroom/updapt-unveils-climate-risk-analysis-module-to-boost-financial-resilience"
        exact
      >
        <NewsroomMediaThree />
      </Route>
      <Route
        path="/resource/blogs/essential-guide-to-sustainability-reporting-practices-for-publicly-listed-companies"
        exact
      >
        <Blog_50 />
      </Route>
      <Route
        path="/resource/blogs/how-can-publicly-traded-companies-start-sustainability-reporting"
        exact
      >
        <Blog_50_1 />
      </Route>
      <Route
        path="/resource/blogs/top-sustainability-metrics-that-should-be-tracked-by-every-corporation"
        exact
      >
        <Blog_50_2 />
      </Route>
      <Route
        path="/resource/blogs/net-zero-tracking-for-public-corporate"
        exact
      >
        <Blog_50_3 />
      </Route>
      <Route
        path="/resource/blogs/supplier-sustainability-assessment-why-it-matters-for-enterprises"
        exact
      >
        <Blog_50_4 />
      </Route>
      <Route
        path="/resource/blogs/preparing-for-sustainability-reporting-regulations"
        exact
      >
        <Blog_50_5 />
      </Route>
      <Route
        path="/resource/blogs/common-reporting-mistakes-and-ways-to-avoid-them"
        exact
      >
        <Blog_50_6 />
      </Route>
      <Route
        path="/resource/blogs/how-can-investor-facing-businesses-use-data-to-improve-their-esg-performance"
        exact
      >
        <Blog_50_7 />
      </Route>
      <Route
        path="/resource/blogs/starter-metrics-and-templates-for-first-time-reporters"
        exact
      >
        <Blog_50_8 />
      </Route>
      <Route
        path="/resource/blogs/communicating-sustainability-reports-effectively"
        exact
      >
        <Blog_50_9 />
      </Route>
      <Route
        path="/resource/blogs/how-has-a-market-leading-enterprise-reduced-emissions-and-gained-the-trust-of-the-investors"
        exact
      >
        <Blog_50_10 />
      </Route>
      <Route
        path="/resource/blogs/why-integrated-esg-platforms-like-updapt-are-the-future-of-climate-risk-and-carbon-emission-management"
        exact
      >
        <Blog_51 />
      </Route>
      <Route
        path="/resource/blogs/how-updapt-integrates-life-cycle-assessment-into-esg"
        exact
      >
        <Blog_52 />
      </Route>
      <Route
        path="/resource/blogs/why-lca-is-essential-for-esg-reporting-&-carbon-goals-2026"
        exact
      >
        <Blog_53 />
      </Route>
      <Route
        path="/resource/blogs/why-modern-enterprises-need-strong-esg-data-management"
        exact
      >
        <Blog_54 />
      </Route>
      <Route
        path="/resource/blogs/why-net-zero-carbon-emissions-are-becoming-mandatory-for-global-enterprises"
        exact
      >
        <Blog_55 />
      </Route>
      <Route
        path="/resource/blogs/common-brsr-reporting-mistakes-and-how-to-avoid-them"
        exact
      >
        <Blog_56 />
      </Route>
      <Route
        path="/resource/blogs/why-supply-chain-esg-matters-for-indonesian-companies"
        exact
      >
        <Blog_57 />
      </Route>
      <Route
        path="/resource/blogs/how-does-updapt-help-indian-enterprises-automate-brsr-data-collection-and-strengthen-esg-reporting"
        exact
      >
        <Blog_58 />
      </Route>
      <Route
        path="/resource/blogs/esg-for-palm-oil-sector-sustainability-challenges-and-solutions"
        exact
      >
        <Blog_59 />
      </Route>
      <Route path="/resource/blogs/future-of-esg-for-idx-companies" exact>
        <Blog_60 />
      </Route>
    </>
  );
}
export default Resource;
